enum CurrentLocationState {
	IDLE = 'idle',
	LOADING = 'loading',
	READY = 'ready',
	HIDDEN = 'hidden',
}

type UseCurrentLocationReturn = {
	state: CurrentLocationState;
	addressLabel: string;
	isAdding: boolean;
	handleAdd: () => void;
};

export {CurrentLocationState};
export type {UseCurrentLocationReturn};
